<div class="container">
  <div class="title-row">
    <h3 class="klabel-huge">Filter by Course Type</h3>
    <app-button
      [text]="'De-select all'"
      class="grey"
      (click)="clearCourseTypesFilter()"
    ></app-button>
  </div>
  <div class="content">
    <div class="section">
      <h4 class="section-title">Course Type Selection</h4>

      <div class="checkbox-group">
        <div class="checkbox-item" *ngIf="courseTypeList.length !== 0">
          <input
            type="checkbox"
            class="kinput"
            [checked]="
              courseTypeList.length === mainFilter.courseTypes.length &&
              courseTypeList.length !== 0
            "
            (change)="selectAllCourseTypesFilter($event)"
            id="selectAllCourseTypes"
          />
          <label for="selectAllCourseTypes" class="checkbox-label">
            Select all course types
            <mat-icon class="checkbox-icon" matTooltip="Select or deselect all course types at once" matTooltipPosition="above">help_outline</mat-icon>
          </label>
        </div>

        <div class="checkbox-item" *ngFor="let courseType of courseTypeList">
          <input
            type="checkbox"
            class="kinput"
            [checked]="checkIncludesRequirement(courseType)"
            (change)="updateCheckboxFilter($event, courseType)"
            [id]="'courseType-' + courseType?.courseType"
          />
          <label [for]="'courseType-' + courseType?.courseType" class="checkbox-label">
            {{ courseType?.courseType }}
            <mat-icon class="checkbox-icon" [matTooltip]="getCourseTypeHelpText(courseType)" matTooltipPosition="above">help_outline</mat-icon>
          </label>
        </div>
      </div>
    </div>
  </div>
</div>
